import {
  WSButton,
  WSChip,
  WSElement,
  WSFlexBox,
  WSInfiniteScroll,
  WSText
} from "@wingspanhq/fe-component-library";
import { BatchType } from "@wingspanhq/wingspan-api-sdk";
import { queriesBatches } from "@query";
import pluralize from "pluralize";

import { useBrowserPageTitle } from "../../../../shared/hooks/useBrowserPageTitle";
import { useUrlQueryFilters } from "../../../../utils/router";
import { TablePayableImportBatches } from "../../components/TablePayableImportBatches/TablePayableImportBatches";
import {
  routeHelpersImportPayablesBatch,
  routeHelpersImportPayablesStart
} from "../../paths";
import { selectorImportBatchesCreatedAtFilter } from "../../selectors/selectorImportBatchesCreatedAtFilter";
import { ImportBatchesFilters } from "../../types";

import styles from "./styles.module.scss";

export const RouteImportPayables: React.FC = () => {
  useBrowserPageTitle("Bulk imports: Payables & deductions");
  const { filters } = useUrlQueryFilters<ImportBatchesFilters>({});

  const goToPayablesImportStart = routeHelpersImportPayablesStart.useGoTo();
  const goToPayableBatchDetails = routeHelpersImportPayablesBatch.useGoTo();

  const queryBatches = queriesBatches.listBatches.useQueryAll({
    filter: {
      type: { eq: BatchType.PAYABLE_IMPORT },
      createdAt: selectorImportBatchesCreatedAtFilter(filters.year)
    }
  });

  const batches = queryBatches.flatData ?? [];
  const totalCount =
    queryBatches.data?.pages?.[0]?.pagination?.totalSize ?? batches.length;

  return (
    <>
      <WSFlexBox.CenterY className={styles.statsContainer}>
        <WSElement className={styles.resultsStats}>
          <WSText.ParagraphXs color="gray500">Showing:</WSText.ParagraphXs>
          <WSChip
            pillText={pluralize("item", totalCount, true)}
            theme="neutral"
            pillType="noBackground"
          />
        </WSElement>
      </WSFlexBox.CenterY>

      <WSInfiniteScroll
        onLoad={() => queryBatches.fetchNextPage()}
        loadMore={batches.length > 0}
        endOfList={!queryBatches.hasNextPage}
        loading={!!queryBatches.isFetchingNextPage}
      >
        <TablePayableImportBatches
          mt="L"
          batches={batches}
          loading={queryBatches.isLoading}
          bottomMessage={
            queryBatches.isFetched && batches.length === 0 ? (
              <WSFlexBox.Center direction="column">
                <WSText mt="2XL">No imports found. </WSText>
                <WSButton.Link onClick={() => goToPayablesImportStart()}>
                  Import payables & deductions
                </WSButton.Link>
              </WSFlexBox.Center>
            ) : null
          }
          onRowClick={batch =>
            goToPayableBatchDetails({ batchId: batch.id as string })
          }
        />
      </WSInfiniteScroll>
    </>
  );
};
